import { EmptyColumn } from '@ioip/core/lib/defaults';
import { IDictionary } from '@ioip/core/lib/utilities';
import React from 'react';
import { IPFieldProps } from '../../types/field-props';

export const PSearchableComboBox = (props: IPFieldProps<any>): JSX.Element => {

    const field = props.field;
    const label = field.label;
    const disabled = field.Disabled;
    const readonly = field.Readonly;
    const required = field.Required;
    const keyBinding = field.KeyBinding;
    const textBinding = field.TextBinding;
    const options = field.DataSourceItems?.ToArray() || [];

    const columns = field.Columns.Where(x => x.Visible).Select(x => x.GetAsFluentUi()).ToArray();
    columns.push(EmptyColumn);

    const onSearch = (keyword: string, item: IDictionary<any>): boolean => {
        let found = false;
        for (const key in item) {
            if (Object.prototype.hasOwnProperty.call(item, key)) {
                const element = item[ key ];
                if (typeof element === 'string') {
                    found = element.normalize("NFD").replace(/[\u0300-\u036f]/g, '').toLowerCase().includes(keyword);
                }
                if (typeof element === 'number') {
                    found = element.toString().includes(keyword);
                }
            }
            if (found) {
                return true;
            }
        }
        return false;
    }

    return <div>Revisar</div>
    // return <SearchableComboBox
    //     key={field.Id}
    //     label={label || ''}
    //     columns={columns}
    //     options={options}
    //     onSearch={onSearch}
    //     onChanged={item => field.Value = item[ keyBinding ]}
    //     selectedKey={props.runtimeField.Value}
    //     keyBinding={keyBinding}
    //     textBinding={textBinding}
    //     required={required}
    //     disabled={disabled || readonly}
    //     errorMessage={props.runtimeField.ErrorMessage || ''}
    // />
}